import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subject } from "rxjs/Subject";
import { User, UserService } from "../../common/services/user/user.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit, OnDestroy {
  public userFirstname: string;
  private unsubscribe = new Subject<void>();

  constructor(private userService: UserService) {}

  ngOnInit() {
    this.userService.get()
      .takeUntil(this.unsubscribe)
      .subscribe((user: User) => {
        this.userFirstname = user.firstName;
      });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/layout/header/header.component.ts